<template>
<div id="app" @click="clicked">

    <router-view v-if="isRouterAlive" />

</div>
</template>

<script>
export default {
    created() {

        // let b = JSON.parse(sessionStorage.getItem("usermsg")).lang;
        // // let b = 33
        // console.log(b)
        // if (b) {
        //     // console.log(JSON.parse(sessionStorage.getItem("usermsg")).sid || 'zh_CN')
        //     this.lang = b;
        //     this.$i18n.locale = this.lang;
        //     console.log(this.$i18n.locale, '1', this.lang)

        // }
    },
    provide() {
        return {
            reload: this.reload
        }
    },
    data() {
        return {
            isRouterAlive: true,
            lTime: new Date().getTime(), // 最后一次点击的时间
      ctTime: new Date().getTime(), //当前时间
      tOut:  ''  //超时时间10min  10 * 60 * 1000
        }
    },
    mounted () {
      window.setInterval(
          this.tTime, 1*60*1000);  

    this.tOut=((JSON.parse(sessionStorage.getItem("usermsg"))? JSON.parse(sessionStorage.getItem("usermsg")).timeout:10 * 60 * 1000)/1)*60*1000
      console.log(this.tOut)

    },
    methods: {
         clicked() {
      this.lTime = new Date().getTime(); //当界面被点击更新点击时间
      console.log(this.lTime)
    },
    tTime() {
      this.cTime = new Date().getTime();
    //   console.log( this.cTime,'当前时间')
      if (this.cTime - this.lTime >= this.tOut) {
          sessionStorage.clear();
          location.reload();

        //   alert('444')
        // if (sessionStorage.getItem("usermsg")) {
        //   // 退出登录
        //   location.reload();
        //   this.$router.push("/login");
        // }
      }
    },
        reload() {
            this.isRouterAlive = false
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        }
    },
}
</script>

<style lang="less">
body /deep/ .el-menu--vertical>.el-menu--popup {
    padding: 0 !important;
}

body /deep/ .el-menu--popup {
    min-width: 50px !important;
}
.tooltio_subject,.el-tooltip__popper {
    max-width: 360px !important;
  
}

body /deep/  .is-dark {

    color: #A9B8D6;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
}
 .el-popover {
    // background: rgb(253, 34, 34) !important;
    // color: #fff !important;
    min-width:0 !important;
    padding: 6px !important;
}

// .el-popper .popper__arrow{
//   border-width: 0px;
// }
//  .el-popper .popper__arrow::after{
//        border-width: 0px;
//     //    border:0
//    }
html,
body {
    // font-family: "微软雅黑";
    height: 100%;
    width: 100% !important;
    min-width: 100% !important;
}

* {
    margin: 0;
    padding: 0;
    list-style: none;
}

#app {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
   
}
</style>
